import type { LessonExtensionRequest, LessonExtensionResponse } from "../types/events";

import { axiosApiInstance } from "@/libs/axios";
import { WORKSPACES_API_ENDPOINTS } from "@/constants/api";

/**
 * Extends a lesson by 10-30 minutes
 */
export const extendLesson = async (
  workspaceId: string,
  lessonId: string,
  data: LessonExtensionRequest,
): Promise<{ message: string; data: LessonExtensionResponse }> => {
  const response = await axiosApiInstance.post(
    WORKSPACES_API_ENDPOINTS(workspaceId).TUTOR.EXTEND_LESSON(lessonId),
    data,
  );

  return response.data;
};
